<template>
  <div class="vx-card p-6">
    <form class="p-4 mb-5 card-bg" @submit.prevent="getB2BDiscount()">
      <h1 class="p-4 text-center mb-5">B2B Yönetimi</h1>
      <div id="satis-islemleri " class="">
        <!--Arama 1.row-->
        <div class="id-inputs vx-row">
          <div class="vx-col islem-id mb-4 md:w-1/6 w-full">
            <label class="text-sm"><b>Kullanıcı</b></label>
            <v-select name="brand" placeholder="Seçiniz" v-model="b2bDiscountSearch.b2BUserId" :options="userList" :clearable="true" :reduce="(userList) => userList.userName" label="userName">
              <span slot="no-options">Eşleşen Veri Yok</span>
            </v-select>
          </div>
          <div class="vx-col islem-id mb-4 md:w-1/6 w-full">
            <div class="vx-row">
              <div class="vx-col md:w-2/3 w-full">
                <label class="text-sm"><b>Ürün</b></label>
                <vs-input type="number" class="w-full" size="large" v-model="b2bDiscountSearch.productId" />
              </div>
              <div class="vx-col mt-5">
                <feather-icon icon="SearchIcon" class="stoke-current cursor-pointer" @click.stop="productSearchPopupParent = true" />
                <product-search v-if="productSearchPopupParent" :productSearchPopupProp="productSearchPopupParent" @ProductSearchPopupClosedChildEmit="ProductSearchPopupClosedParent($event)"></product-search>
              </div>
            </div>
          </div>
          <div class="vx-col islem-id mb-4 md:w-1/6 w-full">
            <label class="text-sm"><b>Marka</b></label>
            <v-select @input="getB2BDiscount()" name="brand" placeholder="Seçiniz" v-model="b2bDiscountSearch.brand" :options="productBrandList" :clearable="true" :reduce="(productBrandList) => productBrandList.brandName" label="brandName">
              <span slot="no-options">Eşleşen Veri Yok</span>
            </v-select>
          </div>
          <div class="vx-col islem-id mb-4 md:w-1/6 w-full">
            <label class="text-sm"><b> Başlangıç</b></label>
            <DatePicker class="w-full" v-model="b2bDiscountItem.start" valueType="format"></DatePicker>
          </div>
          <div class="vx-col islem-id mb-4 md:w-1/6 w-full">
            <label class="text-sm"><b> Bitiş</b></label>
            <DatePicker class="w-full" v-model="b2bDiscountItem.finish" valueType="format"></DatePicker>
          </div>
        </div>
      </div>

      <div class="vx-row ml-0 mr-0 mt-5 mb-5">
        <div class="vx-col md:w-1/2"></div>
        <div class="vx-col md:w-1/2 flex justify-end">
          <vs-button class="ml-3" style=""> Detaylı Ara</vs-button>
        </div>
      </div>
    </form>

    <div class="vx-row ml-0 mr-0 mb-5" style="margin-top:-70px">
      <div class="vx-col md:w-1/2">
        <vs-button class="" @click="discountPopup = true">İndirim Ekle</vs-button>
      </div>
    </div>
    <ag-grid-vue
      style="height: 45vh;"
      ref="agGridTable"
      :gridOptions="gridOptions"
      class="ag-theme-material w-100 my-4 ag-grid-table"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="b2bDiscountList"
      rowSelection="single"
      colResizeDefault="shift"
      :animateRows="true"
      :floatingFilter="true"
      :pagination="true"
      :paginationPageSize="paginationPageSize"
      :suppressPaginationPanel="true"
      :rowClassRules="rowClassRules"
      :context="context"
    ></ag-grid-vue>

    <vs-pagination :total="totalPages" :max="10" v-model="currentPage" />
    <vs-prompt
      :vs-title="b2bDiscountItem.id ? 'İskonto Güncelle # ' + b2bDiscountItem.id : 'İskonto Ekle'"
      vs-button-cancel="border"
      vs-cancel-text="İptal"
      vs-accept-text="Kaydet"
      @vs-accept="saveB2bDiscount()"
      @vs-close="cancel"
      @vs-cancel="cancel"
      vs-color="warning"
      :vs-active.sync="discountPopup"
    >
      <div class="vx-row">
        <div class="vx-col md:w-1/2">
          <div class="mt-6">
            <label class="mr-2"> <b>* İndirim Türü:</b></label>
            <input class="ml-5 mr-2" type="radio" style="transform: scale(1.5)"  name="discountType" id="discountType" v-model="b2bDiscountItem.discountType" value="Brand" />
            <label for="discountType">Marka</label>

            <input class="ml-5 mr-2" type="radio" style="transform: scale(1.5)" id="discountType2" name="discountType" v-model="b2bDiscountItem.discountType" value="Product" />
            <label for="discountType2">Ürün</label>

            <label class="mr-2 ml-10" > <b>* İndirim Kapsamı:</b></label>
            <input class="ml-5 mr-2" type="radio" style="transform: scale(1.5)" name="discountScope" id="discountScope" v-model="b2bDiscountItem.discountScope" value="B2B" />
            <label for="discountScope">Tek B2B</label>

            <input class="ml-5 mr-2" type="radio" style="transform: scale(1.5)" id="discountScope2" name="discountScope" v-model="b2bDiscountItem.discountScope" value="All" />
            <label for="discountScope2">Tüm B2B</label>
          </div>

          <div class="mt-6" v-if="b2bDiscountItem.discountScope == 'B2B'">
            <label class="text-sm"><b>* Kullanıcı</b></label>
            <v-select name="brand" placeholder="Seçiniz" v-model="b2bDiscountItem.b2BUserId" :options="userList" :clearable="true" :reduce="(userList) => userList.userId" label="userName">
              <span slot="no-options">Eşleşen Veri Yok</span>
            </v-select>
          </div>

          <div class="mt-5" v-if="b2bDiscountItem.discountType == 'Brand'">
            <label class="text-sm"><b>* Marka</b></label>
            <v-select name="brand" placeholder="Seçiniz" v-model="b2bDiscountItem.brand" :options="productBrandList" :clearable="true" :reduce="(productBrandList) => productBrandList.brandName" label="brandName">
              <span slot="no-options">Eşleşen Veri Yok</span>
            </v-select>
          </div>

          <div class="mt-5" v-if="b2bDiscountItem.discountType == 'Product'">
            <div class="vx-row">
              <div class="vx-col md:w-1/3 w-full">
                <label class="text-sm"><b>* Ürün Id</b></label>
                <vs-input type="number" class="w-full" size="medium" v-model="b2bDiscountItem.productId" />
              </div>
              <div class="vx-col md:w-1/3 w-full">
                <label class="text-sm"><b> Ürün Adı</b></label>
                <vs-input type="text" readonly="true" class="w-full" size="medium" v-model="b2bDiscountItem.productName" />
              </div>

              <div class="vx-col mt-5">
                <feather-icon icon="SearchIcon" class="stoke-current cursor-pointer" @click.stop="productSearchPopupParent = true" />
                <product-search v-if="productSearchPopupParent" :productSearchPopupProp="productSearchPopupParent" @ProductSearchPopupClosedChildEmit="ProductSearchPopupClosedParent($event)"></product-search>
              </div>
            </div>
          </div>
        </div>
        <div class="vx-col md:w-1/2">
          <div class="vx-row" style="margin-top: -20px;">
            <div class="vx-col md:w-1/3">
              <div class=" " style="margin-top: 35px;">
                <vs-checkbox v-model="b2bDiscountItem.isTimeLimited">Süreli</vs-checkbox>
              </div>
            </div>
            <div class="vx-col md:w-1/3">
              <div class="mt-5" v-if="b2bDiscountItem.isTimeLimited">
                <label class="text-sm"><b> Başlangıç</b></label>
                <DatePicker size="small" class="w-full mt-1" v-model="b2bDiscountItem.start" valueType="format"></DatePicker>
              </div>
            </div>
            <div class="vx-col md:w-1/3">
              <div class="mt-5" v-if="b2bDiscountItem.isTimeLimited">
                <label class="text-sm"><b> Bitiş</b></label>
                <DatePicker class="w-full mt-1" v-model="b2bDiscountItem.finish" valueType="format"></DatePicker>
              </div>
            </div>
          </div>

          <div class="mt-5">
            <label class="text-sm"><b>* İndirim Yüzdesi</b></label>
            <vs-input type="number" size="large" class="w-full" v-model="b2bDiscountItem.discountRate" />
          </div>
        </div>
      </div>
    </vs-prompt>
  </div>
</template>
<script>
import { repository } from "@/_services/repository.js";

import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuesax/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import ProductSearch from "../../Search/ProductSearch.vue";
import CellRendererActions from "../Discount/CellRenderer/CellRendererActions.vue";
import CellRendererDetail from "../Discount/CellRenderer/CellRendererDetail.vue";
export default {
  components: {
    AgGridVue,
    vSelect,
    ProductSearch,
    CellRendererActions,
    CellRendererDetail,
  },
  data() {
    return {
      b2bDiscountList: [],
      b2bDiscountSearch: { id: null, userId: null, productId: null, brand: null, start: null, finish: null, isTimeLimited: null, discountType: null, discountScope: null, b2BUserId: null, b2BUserName: null, date: null },
      b2bDiscountItem: { id: null, userId: null, productId: null, brand: null, start: null, finish: null, isTimeLimited: 0, discountType: null, discountScope: null, b2BUserId: null, b2BUserName: null, date: null },
      userSearch: { userId: null, userName: null },
      userList: [],
      productBrandList: [],
      brandSearch: { brandName: null },

      productSearchPopupParent: false,

      discountPopup: false,
      searchQuery: "",
      delayedSearchTimer: "",
      addNewCust: false,
      gridApi: null,
      rowClassRules: null,
      gridOptions: { rowHeight: 150 },
      context: null,
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
      },
      /* eslint-disable */
      columnDefs: [
        {
          headerName: "Id",
          field: "id",
          filter: true,
          width: 100,
        },

        {
          headerName: "Kullanıcı",
          field: "b2BUserName",
          filter: true,
          width: 200,
        },

        {
          headerName: "Ürün",
          field: "productName",
          filter: true,
          width: 200,
        },

        {
          headerName: "Marka",
          field: "brand",
          filter: true,
          width: 100,
        },
        {
          headerName: "İndirim",
          field: "discountRate",
          filter: true,
          width: 100,
        },
        {
          headerName: "Detaylar",
          field: "detail",
          filter: true,
          editable: true,
          width: 400,
          cellRendererFramework: "CellRendererDetail",
        },
        {
          headerName: "İşlem",
          field: "transactions",
          width: 100,
          cellRendererFramework: "CellRendererActions",
        },
      ],
    };
  },

  watch: {},
  computed: {
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 12;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      },
    },
  },
  methods: {
    ProductSearchPopupClosedParent: async function (v) {
      this.productSearchPopupParent = false;
      if (v) {
        this.b2bDiscountSearch.productId = v.productId;
        this.b2bDiscountItem.productId = v.productId;
        this.b2bDiscountItem.productName = v.productName;
      } else {
        this.b2bDiscountSearch.productId = null;
        this.b2bDiscountItem.productId = null;
        this.b2bDiscountItem.productName = null;
      }
    },
    getB2BDiscount: async function () {
      this.$vs.loading();
      this.b2bDiscountList = await repository.postEntity("B2B/GetB2BDiscount", this.b2bDiscountSearch).then((r) => r.list);
      this.$vs.loading.close();
    },
    getProductBrand: async function () {
      this.productBrandList = await repository.postEntity("Product/GetProductBrand", this.brandSearch).then((r) => r.list);
    },

    getB2BUser: async function () {
      this.userList = await repository.postEntity("B2B/GetB2BUser", this.userSearch).then((r) => r.list);
    },

    saveB2bDiscount: async function () {
      if (this.b2bDiscountItem.id) {
        this.b2bDiscountItem.operation = "Update";
      } else {
        this.b2bDiscountItem.operation = "Insert";
      }
      let result = await this.$swal.fire({
        icon: "warning",
        text: "Devam etmek istediğinize emin misiniz?",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Evet",
        cancelButtonText: "Hayır",
      });
      if (result.isConfirmed) {
        this.$vs.loading();

        await repository.postEntity("B2B/SaveB2BDiscount", this.b2bDiscountItem);
        this.$vs.loading.close();
        await this.$swal.fire({ icon: "success", title: "İndirim oranı kaydedilmiştir." });
        this.b2bDiscountSearch = {};
        this.getB2BDiscount();
      }
    },

    cancel() {
      this.b2bDiscountItem = {};
    },
    close() {},
  },

  created: async function () {
    this.$vs.loading();

    await Promise.all([this.getB2BDiscount(), this.getProductBrand(), this.getB2BUser()]);

    this.$vs.loading.close();
  },
  beforeMount() {
    this.rowClassRules = {};
    this.context = { componentParent: this };
  },
  beforeUpdate() {
    this.gridApi.sizeColumnsToFit();
  },
  mounted() {
    this.gridApi = this.gridOptions.api;

    this.gridApi.sizeColumnsToFit();

    document.addEventListener("keydown", (e) => {
      if (e.keyCode == 27) {
        if (this.discountPopup) this.discountPopup = false;
        this.b2bDiscountItem = {};
      }
    });
  },
};
</script>
